'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icon = require('../setting/icon.base64.js');
exports.default = {
  props: {
    height: {
      type: String,
      default: '100'
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    clickActivied: {
      type: Boolean,
      default: false
    },
    hasTopBorder: {
      type: Boolean,
      default: false
    },
    hasMargin: {
      type: Boolean,
      default: false
    },
    hasBottomBorder: {
      type: Boolean,
      default: true
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    hasVerticalIndent: {
      type: Boolean,
      default: true
    },
    cellStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    itemImg: {
      type: String,
      default: ''
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    arrowIcon: {
      type: String,
      default: icon['arrow_right']
    }
  },
  computed: {
    outputCellStyle: function outputCellStyle() {
      var height = this.height,
          cellStyle = this.cellStyle;
      // return util.extend({"height":height+"px"},cellStyle);

      return _extends({ 'height': height + 'px' }, cellStyle);
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    cellClicked: function cellClicked(e) {
      this.$emit('dofCellClick', { e: e });
    },
    onDelete: function onDelete(e) {
      this.$emit('onDelete', { e: e });
    },
    showEdit: function showEdit(e) {
      this.$emit('onItemPress', { e: e });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-item/index.vue
// module id = 341
// module chunks = 0 1